import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const Loan_Inquiry_StatusTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [roleData, setRoleData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

const fetchRoleData = async () => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("moduleId", M_id);

  try {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const result = await fetchFormData(
      "loan-inquiry-statuses",
      formData,
      "POST"
    );

    if (result) {
      const user = result.states || [];
      const sortedRoles = user.sort((a, b) =>
        a.loan_inquiry_status.localeCompare(b.loan_inquiry_status, undefined, {
          sensitivity: "base",
        })
      );
      setRoleData(sortedRoles);
    }
  } catch (error) {
    console.error("Error fetching inquiry statuses:", error);
    Swal.fire("Error", "Failed to fetch inquiry statuses", "error");
  } finally {
    Swal.close();
  }
};


  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("id", Id); // Send ID in form data
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    const result = await fetchFormData(
      `loan-inquiry-statuses/toggle-status`,
      formData,
      "POST"
    );

    if (result && result.code === 200) {
     await fetchRoleData();
      if (result?.status === 1) {
        topTost({
          title: "Status updated successfully: Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully: Deactive",
          icon: "success",
        });
      }
    } else {
      console.error("Failed to toggle state status:", result?.message);
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_edit === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const is_active = row.original.status;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <FiEdit3
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/master/edit-inquiry-status/${id}?id=${M_id}`)
                      }
                    />
                  )}
                  {permission?.pf_status === 1 &&
                    (is_active === 1 ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    {
      accessorKey: "loan_inquiry_status",
      header: () => "inquiry status",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => {
        const val = info.getValue(); // expected to be 1 or 0 (number)
        const isActive = val === 1;

        const label = isActive ? "Active" : "Deactive";
        const styles = {
          backgroundColor: isActive ? "#cce5ff" : "#fff3cd", // Sky blue / Light yellow
          color: isActive ? "#004085" : "#856404", // Dark blue / Dark yellow
          padding: "4px 10px",
          display: "inline-block",
          fontWeight: "bold",
          fontSize: "12px",
          textAlign: "center",
        };

        return <span style={styles}>{label}</span>;
      },
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchRoleData();
  }, []);
  return (
    <>
      <Table data={roleData} columns={columns} />
    </>
  );
};

export default Loan_Inquiry_StatusTable;
